var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"internal"},[_c('InternalMovingMaterials',{on:{"tab2":_vm.goToTab2}}),_c('AddToInternalMoving')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }